import React from 'react';
interface SectionHeaderProps {
  badge: string;
  badgeIcon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
  centered?: boolean;
}
export function SectionHeader({
  badge,
  badgeIcon,
  title,
  subtitle,
  dark = false,
  centered = false
}: SectionHeaderProps) {
  return <div className={`mb-14 ${centered ? 'text-center' : ''}`} data-id="element-309" data-mp="wquugi5r14i5">
      <span className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide ${dark ? 'bg-brand-yellow/15 text-brand-yellow' : 'bg-brand-blue/10 text-brand-blue'}`} data-id="element-310" data-mp="1ardy7d36loei">
        {badgeIcon}
        {badge}
      </span>
      <h2 className={`mt-3 font-display text-[clamp(28px,4vw,44px)] font-extrabold leading-[1.15] tracking-tight ${dark ? 'text-white' : 'text-ink'} ${centered ? 'mx-auto' : ''}`} data-id="element-311" data-mp="1fi420lvylj73">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 max-w-[560px] text-[17px] leading-relaxed ${dark ? 'text-white/70' : 'text-muted'} ${centered ? 'mx-auto' : ''}`} data-id="element-312" data-mp="3dva2oyx6evwm">
          {subtitle}
        </p> : null}
    </div>;
}